<template>
  <CRow>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="loading">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCol col="12" md="12" v-if="!loading">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <!-- <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
              style="float: left"
            ></DatePicker> -->

            <CButton
              block
              color="success"
              style="float: right; width: 130px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>
        <CCardBody>
          <div class="text-right">
            <p class="text-warning">
              Note : You Can't Edit the Game Once Admin Approved
            </p>
          </div>
          <CDataTable
            pagination
            clickable-rows
            hover
            :fields="fields"
            :items="tableData"
          >
            <template #image="{ item }">
              <td>
                <img :Src="item.image" class="icon" />
              </td>
            </template>
            <template #approved="{ item }">
              <div class="mt-3 ml-5">
                <span class="badge badge-success" v-if="item.approved"
                  >Approved</span
                >
                <span class="badge badge-secondary" v-if="!item.approved"
                  >Pending</span
                >
              </div>
            </template>
            <template #Edit="{ item }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  :disabled="item.approved"
                  style="width: 54px"
                  @click="editToken(item)"
                >
                  Edit </CButton
                ><br /><br />
              </td>
            </template>
            <template #Play="{ item }">
              <td>
                <CButton
                  color="success"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                >
                  <a :href="item.url" class="play-button" target="blank">
                    Play
                  </a> </CButton
                ><br /><br />
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<style src="spinkit/spinkit.min.css"></style>
<script>
import CTableWrapper from "../tables/Table";
import firebase from "firebase";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
const db = firebase.firestore();
export default {
  components: { CTableWrapper, DatePicker },
  data() {
    return {
      loading: true,
      value1: [],
      tableData: [],
      fields: [
        {
          label: "Logo",
          key: "image",
          sortable: true,
        },
        {
          label: "Game Name",
          key: "name",
          sortable: true,
        },
        {
          label: "created",
          key: "created",
          sortable: true,
        },
        {
          label: "Approved Status",
          key: "approved",
          sortable: true,
        },
        {
          key: "Edit",
          sortable: true,
        },
        {
          key: "Play",
          sortable: true,
        },
      ],
    };
  },

  methods: {
    wizard() {
      console.log("sdfsdfsdfs");
      this.$router.push({ name: "CreateGame" });
    },
    editToken(item) {
      this.$router.push({
        name: "EditGame",
        params: { id: item.id },
      });
    },
    async getGames() {
      this.tableData = [];
      const user = await firebase.auth().currentUser;
      //   console.log("usersssss", user);

      db.collection("gamesCategoriesV2")
        .where("user", "==", user.email)
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            // console.log("dataaa", doc.data());
            this.tableData.push(this.assignsmallData(doc));
          });
          this.loading = false;
        })
        .catch((e) => {
          console.log("errror", e);
          this.loading = false;
        });
    },
    assignsmallData(doc) {
      let smallDocument = {
        image: doc.data().thumbnail,
        name: doc.data().title,
        url: doc.data().url,
        isAvail: doc.data().isAvail,
        approved: doc.data().approved,
        created: moment(doc.data().createdTime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        id: doc.id,
      };
      return smallDocument;
    },
  },
  created() {
    this.getGames();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.play-button {
  color: #26994d;
  text-decoration: none;
}
.play-button:hover {
  color: #fff;
  text-decoration: none;
}
.badge {
  font-size: 18x;
  padding: 5px;
}
</style>
